import useSubscriptionCapabilities from './useSubscriptionCapabilities';

export default useSubscriptionCapabilities;
